export default "__VITE_ASSET__U27estn0__"